import React from 'react';

const Tad = () => {
  return <div>Tad</div>;
};

export default Tad;